import { AuthenticationDetails, CognitoUser, CognitoUserPool, CognitoUserSession } from 'amazon-cognito-identity-js';
import { config } from '../config';

const pool = new CognitoUserPool({ UserPoolId: config.cognitoUserPoolId, ClientId: config.cognitoClientId });

export function currentUser(): CognitoUser | null {
  return pool.getCurrentUser();
}

export function getSession(): Promise<CognitoUserSession | null> {
  const user = currentUser();
  if (!user) return Promise.resolve(null);
  return new Promise((resolve) => user.getSession((err: Error | null, session: CognitoUserSession | null) => resolve(err ? null : session)));
}

export async function getIdToken(): Promise<string> {
  const s = await getSession();
  if (!s || !s.isValid()) throw new Error('not signed in');
  return s.getIdToken().getJwtToken();
}

export function signIn(email: string, password: string, newPassword?: string): Promise<CognitoUserSession> {
  const user = new CognitoUser({ Username: email, Pool: pool });
  return new Promise((resolve, reject) => {
    user.authenticateUser(new AuthenticationDetails({ Username: email, Password: password }), {
      onSuccess: resolve,
      onFailure: reject,
      newPasswordRequired: () => {
        if (!newPassword) return reject(new Error('NEW_PASSWORD_REQUIRED'));
        user.completeNewPasswordChallenge(newPassword, {}, { onSuccess: resolve, onFailure: reject });
      },
    });
  });
}

export function signOut() {
  currentUser()?.signOut();
}
